const initialState = {
  sent: [],
  propositionsAccepted: [],
  selectedProposition: null,
  propositionPending: null,  
  sentDonneurOrdre: [],
  receivedDonneurOrdre: [],
};

const propositionReducer = (state = initialState, action) => {
    switch(action.type){
        case "SET_PROPOSITIONS_SENT":
            return { ...state, sent: action.payload };
        case "SET_PROPOSITIONS_ACCEPTED":
            return { ...state, propositionsAccepted: action.payload };
        case "SET_PROPOSITION_PENDING":
            return { ...state, propositionPending: action.payload };
        case "SET_SELECTED_PROPOSITION":
            return { ...state, selectedProposition: action.payload };
        default:
            return state;
    }
};
export default propositionReducer;